export function set_redirect404 (url = null) {
  console.warn(`redirect to ${url || '/404.html'}`);
  if (!(/localhost|192/.test(location.origin))) {
    const redirectUrl = url
      ? url
      : '/404.html';
    location.replace(redirectUrl);
  }
}
